module.exports = __webpack_public_path__ + "images/arrow-right-914869.svg";